import { createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'
import { SocialInnerInsightsCollection } from 'interfaces/socialInsights'

export const SORT_OPPORTUNITIES = 'SORT_OPPORTUNITIES'
export type SortOpportunities = PayloadAction<typeof SORT_OPPORTUNITIES, SocialInnerInsightsCollection>
export const sortOpportunitiesActionCreator = (opportunities: SocialInnerInsightsCollection) =>
  createPayloadAction<typeof SORT_OPPORTUNITIES, SocialInnerInsightsCollection>(SORT_OPPORTUNITIES, opportunities)

type Action =
  | SortOpportunities

export default Action
